import React, { useState, useEffect } from "react";
import axiosInstance from './axiosInstance';

export function Client({ pname, selectedClient, onChange }) {
  const [clients, setClients] = useState([]);

  // Fetch clients
  useEffect(() => {
    axiosInstance.post(`/getclients`)
      .then(res => setClients(res.data))
      .catch(error => console.error(error));
  }, []);

  return (
    <select
      className="w-[220px] h-[40px] flex justify-between items-center rounded-[22px] px-[10px] pl-[20px] border text-[15px] leading-none font-normal text-gray-700 bg-white font-poppins shadow-sm hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-primary-color"
      name="client"
      id="client"
      value={selectedClient || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="" disabled>Select Client</option>
      {clients.map(client => (
        <option key={client.project_clientname} value={client.project_clientname}>
          {client.project_clientname}
        </option>
      ))}
    </select>
  );
}
